import React, { useLayoutEffect } from "react";

import { css, cx } from "@emotion/css";

import { useChatContent } from "@/hooks/useChatContent.ts";
import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { useScreenSize } from "@/theme/responsive.ts";
import { PageDrawer } from "@/uiKit/atoms/page/PageDrawer.tsx";
import { useChatDrawer } from "@/uiKit/atoms/page/PageDrawerState.ts";
import { ChatMessageCard } from "@/uiKit/organisms/ChatMessaging/ChatMessageCard.tsx";
import { PATIENT_NAVIGATION_HEIGHT } from "@/uiKit/organisms/PatientNavigationHeader.tsx";

export type MessagingDrawerProps = {
  className?: string;
  alignWithPageContent?: boolean;
};

export const MessagingDrawer: React.FC<MessagingDrawerProps> = ({ className, alignWithPageContent = false }) => {
  const drawer = useChatDrawer();
  const styles = useStyles(makeStyles);
  const patientId = usePatientIdFromURL();
  const me = Queries.user.useMe({});
  const messages = useChatContent(patientId, me.id);
  const hasMessages = messages && messages.content.length > 0;
  const screenSize = useScreenSize();

  useLayoutEffect(() => {
    if (screenSize != "SM" && screenSize != "MD" && hasMessages && !drawer.touched) {
      drawer.open();
    }
  }, [screenSize, hasMessages, drawer]);

  return (
    <PageDrawer
      isOpen={drawer.isOpen && drawer.isEnabled}
      className={cx(styles.container, className)}
      alignWithPageContent={alignWithPageContent}
    >
      <ChatMessageCard />
    </PageDrawer>
  );
};

const DRAWER_WIDTH_PX = 500;

const makeStyles = () => ({
  container: css({
    position: "sticky",
    top: PATIENT_NAVIGATION_HEIGHT,
    right: 1,
    display: "flex",
    flexDirection: "column",
    margin: 0,
    width: `${DRAWER_WIDTH_PX}px`,
    maxWidth: "95vw",
    height: `calc(100vh - ${PATIENT_NAVIGATION_HEIGHT})`,
  }),
});
